import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ScreenshareOutlineIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <g clipPath="url(#clip0_544_45530)">
      <g clipPath="url(#clip1_544_45530)">
        <path
          d="M13.5039 -0.00195312C14.8846 -0.00193766 16.0039 1.11735 16.0039 2.49805V13.502C16.0039 14.8826 14.8846 16.0019 13.5039 16.002H11.2168C10.9408 16.0018 10.7168 15.778 10.7168 15.502C10.7168 15.2259 10.9408 15.0021 11.2168 15.002H13.5039C14.3323 15.0019 15.0039 14.3304 15.0039 13.502V2.49805C15.0039 1.66963 14.3323 0.998062 13.5039 0.998047H2.5C1.67158 0.998047 1 1.66962 1 2.49805V13.502C1.00002 14.3304 1.67158 15.002 2.5 15.002H4.78711C5.06312 15.0021 5.28711 15.2259 5.28711 15.502C5.28709 15.778 5.06311 16.0018 4.78711 16.002H2.5C1.1193 16.002 1.5462e-05 14.8827 0 13.502V2.49805C3.86552e-06 1.11734 1.11929 -0.00195312 2.5 -0.00195312H13.5039ZM7.98535 5.5C8.11771 5.50011 8.24522 5.55294 8.33887 5.64648L11.7002 9.00781C11.8952 9.20305 11.8953 9.51963 11.7002 9.71484C11.505 9.91005 11.1884 9.90993 10.9932 9.71484L8.48535 7.20703V15.5C8.48525 15.7759 8.26123 15.9998 7.98535 16C7.70935 15.9999 7.48545 15.776 7.48535 15.5V7.20703L4.97656 9.71484C4.78126 9.90964 4.46464 9.90995 4.26953 9.71484C4.0748 9.51971 4.07486 9.20299 4.26953 9.00781L7.63184 5.64648C7.72555 5.55284 7.85287 5.50005 7.98535 5.5Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_544_45530">
        <rect fill="currentColor" height="16" width="16" />
      </clipPath>
      <clipPath id="clip1_544_45530">
        <rect fill="white" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
);
